module.exports = __webpack_public_path__ + "static/media/D2_C3_001.382b80ac.png";